import * as fs from 'fs';
import * as path from 'path';
import { colors } from './const';

const c = colors;

const TSCONFIG_FILES = ['tsconfig.json', 'tsconfig.app.json', 'tsconfig.node.json'] as const;

function getViteScaffoldRoot(): string {
  return path.join(__dirname, '..', '..', 'templates', 'vite-scaffold');
}

/** Copy Vite tsconfig templates only when destination files are absent. */
export function writeViteScaffoldFilesIfMissing(projectRoot: string): string[] {
  const scaffoldRoot = getViteScaffoldRoot();
  const written: string[] = [];

  for (const file of TSCONFIG_FILES) {
    const src = path.join(scaffoldRoot, file);
    const dest = path.join(projectRoot, file);
    if (!fs.existsSync(src)) continue;
    if (fs.existsSync(dest)) continue;
    fs.copyFileSync(src, dest);
    written.push(file);
  }

  if (written.length) {
    console.log(
      `${c.green}OK:${c.reset} Wrote Vite tsconfig scaffold (${written.join(', ')})`,
    );
  }

  return written;
}
